import service from "@/utils/request";

// 点名记录列表
interface rollCallListData {
  page?: number;
  page_size?: number;
  class_id?: number;
  teacher_id?: number;
  course_id?: number;
  staff_id?: number;
  roll_call_start_date?: string;
  roll_call_end_date?: string;
  lesson_start_date?: string;
  lesson_end_date?: string;
  sort_type?: string;
  sort_field?: string;
}
export const rollCallList = (params: rollCallListData) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/list",
    method: "get",
    params,
  });
};
// 点名学员记录列表
interface rollCallStudentListData {
  page?: number;
  page_size?: number;
  roll_call_id?: number;
  student_id?: number;
  roll_call_start_date?: string;
  roll_call_end_date?: string;
  lesson_start_date?: string;
  lesson_end_date?: string;
  teacher_id?: number;
  course_id?: number;
  class_id?: number;
  student_status?: number;
  sort_field?: string;
  sort_type?: string;
}
export const rollCallStudentList = (data: rollCallStudentListData) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/student/list",
    method: "post",
    data,
  });
};
